import { createFileRoute } from '@tanstack/react-router';
import { ProviderConfigSettings } from '@/components/companies/provider-config-settings';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/enrichment/configuration',
)({
  component: () => <ProviderConfigSettings header={false} />,
});
